interface HalfLayoutProps {
  left: React.ReactNode;
  right: React.ReactNode;
  className?: string;
}

/** 젭스 스토리 섹션용 좌우 1:1 2단 레이아웃. lg 미만에서는 세로로 쌓임 */
export const HalfLayout = ({ left, right, className }: HalfLayoutProps) => {
  return (
    <div className={'flex flex-col gap-8 lg:flex-row ' + className}>
      <div className="w-full lg:w-1/2">{left}</div>
      <div className="w-full lg:w-1/2">{right}</div>
    </div>
  );
};
